var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7949 20.9266H7.69492C5.45471 20.9266 4.33461 20.9266 3.47896 20.505C2.72631 20.1342 2.11439 19.5425 1.7309 18.8148C1.29492 17.9875 1.29492 16.9044 1.29492 14.7384V7.77664C1.29492 5.61057 1.29492 4.52753 1.7309 3.7002C2.11439 2.97246 2.72631 2.38079 3.47896 2.00999C4.33461 1.58844 5.45471 1.58844 7.69492 1.58844L12.8949 1.58844C15.1351 1.58844 16.2552 1.58844 17.1109 2.00999C17.8635 2.38079 18.4755 2.97246 18.8589 3.7002C19.2949 4.52753 19.2949 5.61057 19.2949 7.77664V11.741",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3589 14.6686C14.3589 14.2134 14.3589 13.9858 14.457 13.8604C14.5426 13.7511 14.6733 13.6834 14.8147 13.6753C14.9771 13.6659 15.173 13.7921 15.5647 14.0446L20.662 17.3304C20.9857 17.539 21.1475 17.6433 21.2039 17.7748C21.2532 17.8898 21.2532 18.0189 21.2039 18.1339C21.1475 18.2654 20.9857 18.3697 20.662 18.5783L15.5647 21.8641C15.173 22.1166 14.9771 22.2428 14.8147 22.2334C14.6733 22.2253 14.5426 22.1576 14.457 22.0483C14.3589 21.9229 14.3589 21.6953 14.3589 21.2401V14.6686Z",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39697 18.9008H14.3764",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39697 22.8821H11.8172",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.396 26.5452H9.15524",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLive);
export default __webpack_public_path__ + "static/media/menu_live.d3b343e84a7ec96fef7ed143dd8fb622.svg";
export { ForwardRef as ReactComponent };